let category = "basistrager-lastentrager";
const searchIcons = document.querySelectorAll(".js-search_icon");
const tabText = document.querySelector(".js-vehicle-form-heading");
searchIcons.forEach((icon) => {
  icon.addEventListener("click", function () {
    searchIcons.forEach((icon) => {
      icon.classList.remove("active");
    });

    category = this.getAttribute("data-category");
    window.category = category;
    this.classList.add("active");
    tabText.textContent = this.getAttribute("data-text");

    const forms = document.querySelectorAll(".js-search-form");
    forms.forEach((form) => {
      form.classList.add("hidden");
      if (form.dataset.category === category) {
        form.classList.remove("hidden");
      }
    });
  });
});

window.category = category;
